import { render, staticRenderFns } from "./ChangeNameDialog.vue?vue&type=template&id=1127b390&scoped=true&"
import script from "./ChangeNameDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeNameDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChangeNameDialog.vue?vue&type=style&index=0&id=1127b390&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127b390",
  null
  
)

export default component.exports